import { ChangeDetectionStrategy, Component, Inject, Optional, ChangeDetectorRef } from '@angular/core';
import { map, startWith } from 'rxjs/operators';
import { FormGroup, FormArray } from '@angular/forms';
import { ScFieldConfig } from '../../../../../models';
import { autocompleteFilter } from '../../../../../helpers';
import { ScPopoverRef, POPOVER_DATA } from '../../../../sc-popover';
import { ScEndpointFilter } from './../../../../../models/table.model';

export interface AdvancedFilterData {
  columns: string[];
  initialFilters: ScEndpointFilter[];
}

@Component({
  selector: 'sc-advanced-filters',
  templateUrl: './sc-advanced-filters.component.html',
  styleUrls: ['./sc-advanced-filters.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ScAdvancedFiltersComponent {
  public form = new FormGroup({});
  public data = {
    initialFilters: []
  };
  public formFields: ScFieldConfig[] = [
    {
      key: 'initialFilters',
      className: 'flex-row-group',
      type: 'repeat',
      templateOptions: {
        showActions: true,
        addText: 'Add Filter'
      },
      fieldArray: {
        fieldGroup: [
          {
            fieldGroupClassName: 'flex-row',
            fieldGroup: [
              {
                key: 'prop',
                type: 'autocomplete',
                templateOptions: {
                  label: 'Property',
                  appearance: 'fill',
                  required: true,
                  display: data => data,
                  filter: term => autocompleteFilter(term, this._data.columns)
                }
              },
              {
                key: 'comparison',
                type: 'select',
                templateOptions: {
                  label: 'Comparison',
                  appearance: 'fill',
                  required: true,
                  options: [
                    {
                      label: 'Equals',
                      value: 'equals'
                    },
                    {
                      label: 'Does not equals',
                      value: 'equals'
                    },
                    {
                      label: 'Empty or equals',
                      value: 'nullOrEquals'
                    },
                    {
                      label: 'Contains',
                      value: 'contains'
                    },
                    {
                      label: 'Does not contain',
                      value: 'notContains'
                    },
                    {
                      label: 'Empty or contains',
                      value: 'nullOrContains'
                    },
                    {
                      label: 'Greater',
                      value: 'greater'
                    },
                    {
                      label: 'Greater or equal',
                      value: 'greaterOrEqual'
                    },
                    {
                      label: 'Empty or greated or equal',
                      value: 'nullOrGreaterOrEqual'
                    },
                    {
                      label: 'Smaller',
                      value: 'smaller'
                    },
                    {
                      label: 'Smaller or equal',
                      value: 'smallerOrEqual'
                    },
                    {
                      label: 'Empty or smaller or equal',
                      value: 'nullOrSmallerOrEqual'
                    },
                    {
                      label: 'One of',
                      value: 'oneOf'
                    },
                    {
                      label: 'Not one of',
                      value: 'notOneOf'
                    },
                    {
                      label: 'Starts with',
                      value: 'startsWith'
                    },
                    {
                      label: 'Ends with',
                      value: 'endsWith'
                    }
                  ]
                },
                expressionProperties: {
                  'templateOptions.disabled': '!model.prop'
                }
              },
              {
                key: 'value',
                name: 'value',
                type: 'dynamic',
                wrappers: [],
                templateOptions: {
                  label: 'Value',
                  appearance: 'fill'
                },
                expressionProperties: {
                  'templateOptions.disabled': '!model.comparison'
                },
                hooks: {
                  onInit: field => {
                    const prop = field.form.get('prop');
                    field.templateOptions.selectedType = prop.valueChanges.pipe(
                      startWith(prop.value),
                      map((value: string) => {
                        if (!value) {
                          return 'input';
                        }
                        if (value.toLowerCase().includes('date')) {
                          return 'datetime';
                        }
                        return 'input';
                      })
                    );
                  }
                }
              }
            ]
          }
        ]
      }
    }
  ];
  constructor(
    private _cd: ChangeDetectorRef,
    public popoverRef: ScPopoverRef<ScEndpointFilter[]>,
    @Optional() @Inject(POPOVER_DATA) private _data: AdvancedFilterData
  ) {
    this.data.initialFilters = this._data.initialFilters;
  }

  public close(data?: any) {
    this.popoverRef.close(data ? data.initialFilters : null);
  }

  public clear() {
    this.data.initialFilters = [];
    this._cd.markForCheck();
  }
}
